import { AGENT_ROLE } from '@/constants';
import { useAuthStore } from '@/stores/useAuthStore';
import type { Context } from './MiddlewareInterface';

export default async function loginMiddleware({ to }: Context) {
  const authStore = useAuthStore();
  await authStore.$persistedState.isReady();

  if (to.query.data) {
    try {
      authStore.verify(String(to.query.data));
      authStore.decodeUser();
    } catch (err) {
      console.error(err);

      return { name: 'login-module', query: to.query };
    }
  }

  if (to.path === '/' && authStore.isValidToken) {
    if (authStore.role !== AGENT_ROLE) {
      return { name: 'admin-login', query: { data: authStore.token } };
    }

    window.location.href = authStore.getBaseUrl();
  }
}
